import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-actions-benefits-institution',
  templateUrl: './actions-benefits-institution.component.html',
  styleUrls: ['./actions-benefits-institution.component.scss']
})
export class ActionsBenefitsInstitutionComponent implements OnInit {
  @Input() benefitData;
  benefitForm: FormGroup;

  // File variables
  fileImg64C: string | ArrayBuffer;
  fileImg64M: string | ArrayBuffer;
  wrongSize: any[] = [];

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.benefitForm = this.fb.group({
      logoCarrusel: ['', Validators.required],
      img64C: [(this.benefitData ? this.benefitData.img64C : null), Validators.required],
      logoModal: ['', Validators.required],
      img64M: [(this.benefitData ? this.benefitData.img64M : null), Validators.required],
      name: [(this.benefitData ? this.benefitData.name : null), Validators.required],
    });

    this.benefitData ? this.fileImg64C = this.benefitData.logoCarrusel : this.fileImg64C = '';
    this.benefitData ? this.fileImg64M = this.benefitData.logoModal : this.fileImg64M = '';

    if (this.benefitData && this.benefitData.id) {
      this.benefitForm.get('logoCarrusel').setValidators(null);
      this.benefitForm.get('img64C').setValidators(null);
      this.benefitForm.get('logoModal').setValidators(null);
      this.benefitForm.get('img64M').setValidators(null);
      this.benefitData.img64CUpload = false; // viene por defecto pero es bueno tenerlo en cuenta
      this.benefitData.img64MUpload = false; // viene por defecto pero es bueno tenerlo en cuenta
    }
  }

  getBase64(event, place: string): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        switch (place) {
          case 'carrousel':
            if (image.width === 72 && image.height === 48) {
              this.wrongSize['c'] = null;
              this.fileImg64C = image.src;
              this.benefitForm.get('logoCarrusel').setValue((event.target.files[0]).name);
              this.benefitForm.get('img64C').setValue(this.fileImg64C.split(',')[1]);
              if (this.benefitData && this.benefitData.id) {
                this.benefitData.img64CUpload = true;
              } // Si es editar setea true | si es lectura es indiferente (no se usa)
            } else {
              this.wrongSize['c'] = 'Resolución de imagen carrusel no permitida (requerida: 72px x 48px)';
              return false;
            }
            break;
          case 'modal':
            if (image.width === 165 && image.height === 110) {
              this.wrongSize['m'] = null;
              this.fileImg64M = image.src;
              this.benefitForm.get('logoModal').setValue((event.target.files[0]).name);
              this.benefitForm.get('img64M').setValue(this.fileImg64M.split(',')[1]);
              if (this.benefitData && this.benefitData.id) {
                this.benefitData.img64MUpload = true;
              } // Si es editar setea true | si es lectura es indiferente (no se usa)
            } else {
              this.wrongSize['m'] = 'Resolución de imagen modal no permitida (requerida: 165px x 110px)';
              return false;
            }
            break;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }

  isValid(): void {
    const dataToSend: any = this.benefitForm.value;
    if (this.benefitData && this.benefitData.id) {
      dataToSend.id = this.benefitData.id;
      dataToSend.img64CUpload = this.benefitData.img64CUpload;
      dataToSend.img64MUpload = this.benefitData.img64MUpload;
    }

    (this.benefitData ? dataToSend.id = Number(this.benefitData['id']) : delete dataToSend.id);
    this.activeModal.close(dataToSend);
  }
}
